export const FETCH_RELEASE_NOTES_REQUEST = 'FETCH_RELEASE_NOTES_REQUEST';
export const FETCH_RELEASE_NOTES_SUCCESS = 'FETCH_RELEASE_NOTES_SUCCESS';
export const FETCH_RELEASE_NOTES_FAILURE = 'FETCH_RELEASE_NOTES_FAILURE';

export const FETCH_RELEASE_NOTE_REQUEST = 'FETCH_RELEASE_NOTE_REQUEST';
export const FETCH_RELEASE_NOTE_SUCCESS = 'FETCH_RELEASE_NOTE_SUCCESS';
export const FETCH_RELEASE_NOTE_FAILURE = 'FETCH_RELEASE_NOTE_FAILURE';

export const UPDATE_RELEASE_NOTES_REQUEST = 'UPDATE_RELEASE_NOTES_REQUEST';
export const UPDATE_RELEASE_NOTES_SUCCESS = 'UPDATE_RELEASE_NOTES_SUCCESS';
export const UPDATE_RELEASE_NOTES_FAILURE = 'UPDATE_RELEASE_NOTES_FAILURE';

export const DELETE_RELEASE_NOTES_REQUEST = 'DELETE_RELEASE_NOTES_REQUEST';
export const DELETE_RELEASE_NOTES_SUCCESS = 'DELETE_RELEASE_NOTES_SUCCESS';
export const DELETE_RELEASE_NOTES_FAILURE = 'DELETE_RELEASE_NOTES_FAILURE';

export const OPEN_EDIT_RELEASE_NOTE_PAGE = 'OPEN_EDIT_RELEASE_NOTE_PAGE';
export const OPEN_EDIT_RELEASE_NOTE_PAGE_SUCCESS = 'OPEN_EDIT_RELEASE_NOTE_PAGE_SUCCESS';

export const CLEAR_RELEASE_NOTE_ERRORS = 'CLEAR_RELEASE_NOTE_ERRORS';
export const CLEAR_RELEASE_NOTE_SUCCESS = 'CLEAR_RELEASE_NOTE_SUCCESS';